module.exports = __webpack_public_path__ + "img/violet_057.1d49f697.png";